export default function (context) {
  return new Promise((resolve, reject) => {
    const copyLink = document.createElement('a')
    const copyLinkId = 'cb' + new Date().getTime()
    copyLink.setAttribute('id', copyLinkId)
    copyLink.style.display = 'none'
    copyLink.setAttribute('data-clipboard-text', context)
    document.body.appendChild(copyLink)
    import('clipboard').then((clipboard) => {
      const ClipboardJS = clipboard.default
      const cb = new ClipboardJS(`#${copyLinkId}`)
      copyLink.click()
      document.body.removeChild(copyLink)
      cb.destroy()
      resolve(true)
    }).catch((err) => {
      reject(err)
    })
  })
}
